<template>
  <div class="stock-delay-apply">
    <div class="device-msg">
      <div class="item-title">{{ $t('components_change_stock_order_apply.she_bei_xin_xi') }}</div>
      <el-row :gutter="20">
        <el-col :span="6">
          {{ $t('components_change_stock_order_apply.chan_pin_pin_pai') }}：{{form.productBrand}}
        </el-col>
        <el-col :span="6">
          {{ $t('components_change_stock_order_apply.chan_pin_xing_hao') }}：{{form.productCode}}
        </el-col>
        <el-col :span="6">
          {{ $t('components_change_stock_order_apply.ji_shen_hao') }}：{{form.bodyNum}}
        </el-col>
        <el-col :span="6">
          {{ $t('components_change_stock_order_apply.she_bei_lei_xing') }}：{{form.deviceBizType}}
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="6">
          {{ $t('components_change_stock_order_apply.zai_ku_tian_shu') }}：{{form.stockInDay}}
        </el-col>
        <el-col :span="6">
          {{ $t('components_change_stock_order_apply.ku_cun_kai_shi_ri_qi') }}：{{$momentLocal(form.stockStartDate, 'YYYY-MM-DD')}}
        </el-col>
        <el-col :span="6">
          {{ $t('components_change_stock_order_apply.mian_fei_shi_chang') }}：{{form.freeDuration}}{{getDicValue('crm_sharing_rule_free_unit', form.freeUnit)}}
        </el-col>
      </el-row>
    </div>
    <div class="form-content">
      <div class="item-title">{{ $t('components_change_stock_order_apply.shen_qing_xin_xi') }}</div>
      <el-form
        label-position="top"
        :model="form"
        :rules="rules"
        ref="form"
      >
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item
              :label="$t('components_change_stock_order_apply.sqycts')"
              prop="newExtendDays"
            >
              <el-input
                v-model="form.newExtendDays"
                type="number"
                :min="0"
                :disabled="isPreview"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item :label="$t('components_change_stock_order_apply.yjkcsfrq')">
              <!-- {{form.stockFeeDate}} -->
              {{stockFeeDate}}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col>
            <el-form-item
              :label="$t('components_change_stock_order_apply.shen_qing_yuan_yin')"
              prop="changeDesc"
            >
              <el-input
                type="textarea"
                v-model="form.changeDesc"
                :disabled="isPreview"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
  </div>
</template>

<script>
import apis from '@/utils/apis';

export default {
  name: '',
  mixins: [],
  components: {},
  props: {
    model: {
      type: Object,
      default() {
        return {
          type: '', // edit, watch,
          changeId: '', // 必填， 库存管理列表传orderId, 审批列表：传bizId,
          row: null, // 库存管理列表必填，传：row，
        };
      }
    },
  },
  data() {
    return {
      isEdit: false,
      form: {
        changeOrderId: '',
        // 申请原因
        changeDesc: '',
        // 新延期天数
        newExtendDays: '',
        orderCode: '',
        orderId: '',
        oldExtendDays: '',

        productBrand: '',
        productCode: '',
        bodyNum: '',
        deviceBizType: '',
        stockInDay: '',
        stockStartDate: '',
        freeDays: '',
        stockFeeDate: '',

        freeDuration: '',
        freeUnit: ''
      },
    };
  },
  computed: {
    rules() {
      return {
        changeDesc: {
          max: 200,
          message: this.$t('Common.com_rules_length_max', [200]),
          required: true,
        },
        newExtendDays: {
          required: true,
          message: this.$t('Common.com_required'),
        },
      };
    },
    isPreview() {
      return this.model.type === 'watch';
    },
    // 预计库存收费日期 = 库存开始日期 + 免费时长 + 申请延期天数
    stockFeeDate() {
      let { newExtendDays = 0, freeDuration = 0 } = this.form;
      const stockStartDate = this.form.stockStartDate;
      newExtendDays = Number(newExtendDays);
      freeDuration = Number(freeDuration);
      if (stockStartDate) {
        const days = newExtendDays + freeDuration;
        const dayMs = 24 * 3600 * 1000;
        const startDateMs = (new Date(stockStartDate)).getTime();
        const sum = days * dayMs + startDateMs;
        // return moment(sum).format('YYYY-MM-DD HH:mm:ss');
        return this.$momentLocal(sum, 'YYYY-MM-DD');
      }
      return '';
    }
  },
  watch: {},
  filters: {},
  directives: {},
  methods: {
    apply() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          const reqUrl = this.isEdit ? apis.stockOrderChangeUpdate : apis.stockOrderChangeAdd;
          this.$postJSON(reqUrl, this.getApplyReqData(), true).then(() => {
            this.$message({
              type: 'success',
              message: this.$t('Common.com_handle_success'),
            });
            this.$emit('success');
          });
        }
      });
    },
    onConfirm() {
      if (this.model.type === 'watch') {
        this.$emit('close');
        return;
      }
      this.apply();
    },
    getApplyReqData() {
      const ret = {
        ...this.form,
        isStartApprove: 1,
        newExtendDays: Number(this.form.newExtendDays),
        oldExtendDays: Number(this.form.oldExtendDays),
      };

      if (!ret.orderId) {
        ret.orderId = this.model.changeId;
      }
      return ret;
    },
    getInfo() {
      this.$getJSON(`${apis.stockOrderChangeInfo}/${this.model.changeId}`).then((res) => {
        this.$setFormatData(this.form, res.data);

        if (this.form.changeDesc || this.form.newExtendDays) {
          this.isEdit = true;
        }
      });
    }
  },
  created() { },
  mounted() {
    if (this.model.row) {
      if (this.model.row.productCode) {
        this.$setFormatData(this.form, this.model.row);
        this.form.oldExtendDays = this.model.row.extendDays;
      } else {
        this.getInfo();
      }
    } else {
      this.getInfo();
    }
  },
};
</script>

<style lang="scss">
.stock-delay-apply {
  .device-msg {
    .el-col {
      line-height: 35px;
    }
  }
  .form-content {
    margin-top: 20px;
  }
}
</style>
